"use client";

import { createIcon } from "@chakra-ui/react";

const CartBagSvgIcon = createIcon({
  displayName: "CartBagSvgIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M4 22V6H8C8 4.9 8.39167 3.95833 9.175 3.175C9.95833 2.39167 10.9 2 12 2C13.1 2 14.0417 2.39167 14.825 3.175C15.6083 3.95833 16 4.9 16 6H20V22H4ZM6 20H18V8H16V11H14V8H10V11H8V8H6V20ZM10 6H14C14 5.45 13.8043 4.97933 13.413 4.588C13.0217 4.19667 12.5507 4.00067 12 4C11.4493 3.99933 10.9787 4.19533 10.588 4.588C10.1973 4.98067 10.0013 5.45133 10 6Z"
      fill="black"
    />
  ),
});

export default CartBagSvgIcon;
